import { Grid, makeStyles, Paper, Button, Hidden, Typography, Link } from "@material-ui/core";
import React, { useEffect } from "react";
import { AuthUserContext, withAuthentication } from "../Session";
import SignInForm from "./SignInForm";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import { useTranslation } from "react-i18next";
import login_img from "../../assets/images/login.jpg";
import LangSelect from "../Navigation/LangSelect";

const SignInPage = () => {
  const history = useHistory();

  const { t } = useTranslation();

  const goToUserHome = (user) => {
    user.program.length > 1 ? history.push(ROUTES.PROGRAMS) : history.push(`${ROUTES.PROGRAMS}/${user.program[0].id}${ROUTES.GROUPS}`);
  };

  return (
    <>
      {<AuthUserContext.Consumer>{(authUser) => !!authUser && goToUserHome(authUser)}</AuthUserContext.Consumer>}

      <Hidden xsDown>
        <Grid container justify="center" alignItems="center" style={{ minHeight: "80vh", marginTop: 0 }}>
          <Grid container item lg={7} xs={12} xl={6} md={6}>
            <Paper
              variant="outlined"
              style={{
                width: "100%",
                borderRadius: 16,
                "background-image": "linear-gradient(0deg,rgba(255,255,255,.5),rgba(255,255,255,.5)),url()",
                paddingTop: "1.5rem"
              }}
            >
              <Grid
                container
                style={{
                  borderTopLeftRadius: 16,
                  borderBottomLeftRadius: 16,
                }}
              >
                <Hidden smDown>
                  <Grid
                    container
                    item
                    alignItems="center"
                    justify="center"
                    sm={6}
                    style={{
                      borderTopLeftRadius: 16,
                      borderBottomLeftRadius: 16,
                      backgroundPosition: "-95px",
                      backgroundSize: "cover",
                      "background-image": "linear-gradient(0deg,rgba(255,255,255,.15),rgba(255,255,255,.15)), " + `url(${login_img})`,
                    }}
                  ></Grid>
                </Hidden>

                <Grid item justify="center" sm={12} lg={6} container style={{ padding: 32 }}>
                  <SignInForm />
                </Grid>
              </Grid>
            </Paper>
            <Grid
              container
              justify="center"
              alignItems="center"
              style={{
                marginTop: 16,
                color: "rgba(0, 0, 0, 0.54)",
              }}
            >
              <a
                href={"mailto:info@bexencardio.com?Subject=Error%20en%20iniciar%20sesion"}
                style={{ textDecoration: "none" }}
              >
                <Typography color="textSecondary">{t("common.reportCreteAccountError")}</Typography>
              </a>

              <Typography color="textSecondary" style={{ marginRight: 4, marginLeft: 4 }}>
                ·
              </Typography>

              <a
                href={t("common.bexencardioWebContact")}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none", marginRight: 4, marginLeft: 4 }}
              >
                <Typography color="textSecondary">bexencardio.com</Typography>
              </a>

              <Typography color="textSecondary" style={{ marginRight: 4, marginLeft: 4 }}>
                ·
              </Typography>

              <LangSelect />
            </Grid>
          </Grid>
        </Grid>
      </Hidden>
      <Hidden smUp>
        <Grid container alignItems="center" style={{ minHeight: "90vh" }}>
          <SignInForm />
        </Grid>
      </Hidden>
    </>
  );
};

export default withAuthentication(SignInPage);
